import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import { Meta } from '@angular/platform-browser';

@Component({

  selector: 'app-transit-time',

  templateUrl: './transit-time.component.html',

  styleUrls: ['./transit-time.component.css']

})

export class TransitTimeComponent implements OnInit {

  lstCars = [];

  lstRoutes = [];

  lst_Reports = [];

  lst_Search = [];

  lstMobileType = [];

  lst_GeoFence: any = [];

  tiResultTrip_0: number = 0;

  tiResultTrip_1: number = 0;

  tiResultTrip_2: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    ID: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    iSDGeoFence: new FormControl('-1'),

    iSGeoFence: new FormControl('-1'),

    iDGeoFence: new FormControl('-1'),

    tiResultTrip: new FormControl('-1'),

    tiMobileType: new FormControl('-1'),

    tiTripStatus: new FormControl('-1'),

    tiLoadImportance: new FormControl('-1'),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _other: OtherService,

    private metaService: Meta

  ) { }

  ngOnInit(): void {

    this.getMobileType();

    this.getGeoFence();

    this.getCars();

    this.getRoutes();

  }

  getMobileType = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`GetMobileType_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstMobileType = res;

  }

  getGeoFence = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GeoFence = res;

  }

  getCars = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = (await axios.post(`FleetYar_Car_List_New`, this._other.stringNumberToNumber(model))).data;

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstCars = res;

  }

  getRoutes = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TransitRoute_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstRoutes = res;

  }

  search_Report = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Transit_Trip_TimeReport`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Reports = res;

    this.lst_Search = res;

    this.tiResultTrip_0 = 0;

    this.tiResultTrip_1 = 0;

    this.tiResultTrip_2 = 0;

    this.lst_Reports.forEach((el: any) => {

      this.tiResultTrip_0 += el.tiResultTrip_0;

      this.tiResultTrip_1 += el.tiResultTrip_1;

      this.tiResultTrip_2 += el.tiResultTrip_2;

    })


  }

  filter_list(val: any) {

    this.lst_Reports = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strFullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Reports = this.lst_Search;

    }

  }


}
